<template>
	<div class="full page_container">

		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="售后单" v-if="findChildren(177)!==-1" name="exchangeorder" style="height: 100%;">
				<exchangeorder-index />
			</el-tab-pane>	
			<el-tab-pane label="待处理售后单" v-if="findChildren(146)!==-1" name="pendingexchange" style="height: 100%;">
				<pendingexchange-index />
			</el-tab-pane>
			<el-tab-pane label="售后差价" v-if="findChildren(182)!==-1" name="exchangediff" style="height: 100%;">
				<exchangediff-index />
			</el-tab-pane>	
			<el-tab-pane label="售后任务" v-if="findChildren(181)!==-1" name="exchangetask" style="height: 100%;">
				<exchangetask-index />
			</el-tab-pane>	
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import pendingexchangeIndex from './pendingexchange/index.vue'
	import exchangeorderIndex from './exchangeorder/index.vue'
	import exchangetaskIndex from './exchangetask/index.vue'
	import exchangediffIndex from './exchangediff/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				activeName: '',
				activeIndex: '',
				departmentChildren: []
			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			if (this.departmentChildren.length != 0) {
				this.activeName = this.departmentChildren[0].controller
				
			}
			// this.activeName = 'exchangeorder'
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			}
		},
		components: {
			pendingexchangeIndex,
			exchangeorderIndex,
			exchangetaskIndex,
			exchangediffIndex
		}
	}
</script>
